import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["width", "minWidth", "maxWidth", "wide", "height", "minHeight", "maxHeight", "tall"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var widthAttributesList = {
  width: true,
  minWidth: true,
  maxWidth: true,
  wide: true
};
export var heightAttributesList = {
  height: true,
  minHeight: true,
  maxHeight: true,
  tall: true
};
export var sizeAttributesList = _objectSpread(_objectSpread({}, heightAttributesList), widthAttributesList);

var makeCSS = function makeCSS(theme, cssParameter, value) {
  if (typeof value !== 'undefined') {
    return "".concat(cssParameter, ": ").concat(theme.breakpoints.mapCodeToValue(value, theme.spacing), ";");
  }

  return '';
};

export var widthAttributes = function widthAttributes(_ref) {
  var theme = _ref.theme,
      width = _ref.width,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      wide = _ref.wide;
  return "\n    ".concat(makeCSS(theme, 'width', width), "\n    ").concat(makeCSS(theme, 'min-width', minWidth), "\n    ").concat(makeCSS(theme, 'max-width', maxWidth), "\n    ").concat(wide ? 'width: 100%;' : '', "\n");
};
export var heightAttributes = function heightAttributes(_ref2) {
  var theme = _ref2.theme,
      height = _ref2.height,
      minHeight = _ref2.minHeight,
      maxHeight = _ref2.maxHeight,
      tall = _ref2.tall;
  return "\n    ".concat(makeCSS(theme, 'height', height), "\n    ").concat(makeCSS(theme, 'min-height', minHeight), "\n    ").concat(makeCSS(theme, 'max-height', maxHeight), "\n    ").concat(tall ? 'height: 100%;' : '', "\n");
};
export var sizeAttributes = function sizeAttributes(props) {
  return "\n    ".concat(widthAttributes(props), "\n    ").concat(heightAttributes(props), "\n");
};
export var extractSizeProps = function extractSizeProps(_ref3) {
  var width = _ref3.width,
      minWidth = _ref3.minWidth,
      maxWidth = _ref3.maxWidth,
      wide = _ref3.wide,
      height = _ref3.height,
      minHeight = _ref3.minHeight,
      maxHeight = _ref3.maxHeight,
      tall = _ref3.tall,
      restSizeProps = _objectWithoutProperties(_ref3, _excluded);

  return {
    restSizeProps: restSizeProps,
    sizeProps: {
      width: width,
      minWidth: minWidth,
      maxWidth: maxWidth,
      wide: wide,
      height: height,
      minHeight: minHeight,
      maxHeight: maxHeight,
      tall: tall
    }
  };
};